import { ChartIcon } from "@/app/icons/chart"
import { Trans } from "@lingui/react/macro"
import { Button } from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { FloorPriceChartMoleculeReatom } from "./floor-price-chart-molecule.reatom"

export const FloorPriceChartToggleReatom = reatomComponent(() => {
  const { openedAtom, toggleChart } = useMolecule(FloorPriceChartMoleculeReatom)
  const opened = openedAtom()

  return (
    <Button
      onClick={toggleChart}
      variant="ghost"
      className="flex items-center gap-2 hover:bg-transparent"
    >
      <ChartIcon />
      <span className="text-nowrap text-foreground/40">
        {opened ? <Trans>Close Chart</Trans> : <Trans>Show Chart</Trans>}
      </span>
    </Button>
  )
})
